var exports = {
  "N": "xe564cbfb--0697ec--element",
};

module.exports = exports;
